module.exports = __webpack_public_path__ + "static/media/dealtOnly789_1.02f9557f.svg";